import { createCustomAction } from 'typesafe-actions';

import { AuthenticationMethod } from '../../utils/Api';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$FETCH_HISTORICAL_ORDERS/REQUESTED';
const BLOCKED = '$FETCH_HISTORICAL_ORDERS/BLOCKED';
const APPROVED = '$FETCH_HISTORICAL_ORDERS/APPROVED';
const SUCCEEDED = '$FETCH_HISTORICAL_ORDERS/SUCCEEDED';
const FAILED = '$FETCH_HISTORICAL_ORDERS/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      authenticationMethod?: AuthenticationMethod;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, standardEmptyACC),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
